import type { useAppProps } from 'antd/es/app/context';
import type { ReactNode } from 'react';

type ModalApi = useAppProps['modal'];

export interface ConfirmOptions {
  title: string;
  /** Итог действия: что, сколько, у кого — человек должен видеть, что именно подтверждает. */
  details: ReactNode[];
  /** Кнопка называет действие («Да, списать 3 кг»), а не «ОК» — по ней не нажмёшь машинально. */
  okText: string;
  cancelText: string;
  danger?: boolean;
}

/**
 * «Вы уверены?» перед списанием и отгрузкой (ADR-0011 п. 6, требование бизнеса).
 * true — подтвердили; false — отказались или закрыли окно.
 */
export function confirmAction(modal: ModalApi, o: ConfirmOptions): Promise<boolean> {
  return new Promise((resolve) => {
    modal.confirm({
      title: o.title,
      content: (
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          {o.details.map((d, i) => (
            <li key={i}>{d}</li>
          ))}
        </ul>
      ),
      okText: o.okText,
      cancelText: o.cancelText,
      okButtonProps: { danger: o.danger ?? true },
      // Enter и случайный клик по фону не подтверждают: по умолчанию в фокусе «Отмена».
      autoFocusButton: 'cancel',
      maskClosable: false,
      onOk: () => {
        resolve(true);
      },
      onCancel: () => {
        resolve(false);
      },
    });
  });
}
